import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IGenericType } from '@library/common/generictype';

export interface ICaptureContext {
   jwt: string;
   payload: {
      clientLibrary: string;
      clientLibraryIntegrity: string;
   };
}

export interface ISessionRequest {
   account: number;
   notes: string;
   payments: { id: string; amount: number }[];
   override?: number;
}

@Injectable({
   providedIn: 'root'
})
export class CheckoutService {
   private readonly endpoint = 'cybersource/session';
   private readonly paymentEndpoint = 'cybersource/payment';

   constructor(
      private http: HttpClient,
   ) {}

   getSession( request: ISessionRequest ): Observable<ICaptureContext> {
      return this.http.post<IGenericType>( this.endpoint, request, { params: { useLambda: true } } ).pipe(
         map( res => res.response as ICaptureContext ),
      );
   }

   getPaymentDetails( jwt: string ): Observable<any> {
      return this.http.get<IGenericType>( this.paymentEndpoint, {
         headers: new HttpHeaders({ Authorization: `Bearer ${jwt}` }),
         params: { useLambda: true },
      }).pipe(
         map( res => res.response?.transactionId ),
      );
   }
}
